import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTabsComponent } from './shared-tabs.component';

@NgModule({
  declarations: [SharedTabsComponent],
  exports: [SharedTabsComponent],
  imports: [CommonModule],
})
export class SharedTabsModule {}
